import React, { useEffect, useRef, useState } from "react";
import LineShowInfo from "../Guarantee/LineShowInfo";
import ButtonComponent from "../elements/ButtonComponent";
import { AnimatePresence, motion } from "framer-motion";
import { childVariants } from "../../animation/RoutesAnimations";
import Lottie from "react-lottie";
import animationData from "../../../src/jsons/LoadingBg.json";
import Payment from "../../../src/jsons/Payment.json";
import { useQuery } from "@tanstack/react-query";
import { CustomAxiosRequestConfig, axiosPrivate } from "../../api/axios";
import { STORE_PROMISSORY_NOTE_GET } from "../../api/apiClient";

interface GuaranteeProps {
  onBack?: any;
  paymentAmount: any;
  formNo?: any;
  setFormNo?: any;
  setIsLoadingContents?: any;
}
const variants = {
  hidden: {
    opacity: 0,
    transition: { duration: 0 },
  },
  visible: {
    opacity: 1,
    transition: { duration: 0.5 },
  },
};

const Guarantee: React.FC<GuaranteeProps> = ({
  onBack,
  paymentAmount,
  setFormNo,
  formNo,
}) => {
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const access_token = localStorage.getItem("access_token");
  const store_uid = localStorage.getItem("selected_store_uid");
  const [notPayed, setNotPayed] = useState(true);
  const handleCheckboxChange = () => {
    setIsCheckboxChecked(!isCheckboxChecked);
  };
  const goToPayment = () => {
    setNotPayed(false);
  };

  const [isLoadingContents, setIsLoadingContents] = useState<boolean>(false);
  const [garanteeData, setGaranteeData] = useState<any>(undefined);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    renderer: "svg",
  };
  const defaultOptionsCard = {
    loop: true,
    autoplay: true,
    animationData: Payment,
    renderer: "svg",
  };

  const pdfRef = useRef(null);

  const getGrantee = () =>
    axiosPrivate

      .get(
        STORE_PROMISSORY_NOTE_GET(store_uid),
        // ``,
        {
          headers: {
            // prettier-ignore
            "accept": "application/json",
            // prettier-ignore
            "Authorization": `Bearer ${access_token}`,
            "Content-Type": "multipart/form-data",
          },
          withCredentials: true,
        }
      )
      .then((res) => res.data);

  const garanteeQuery = useQuery({
    queryKey: ["garantee"],
    queryFn: () => getGrantee(),
  });

  useEffect(() => {
    setGaranteeData(garanteeQuery.data);
  }, [garanteeQuery.data, garanteeData]);

  return (
    <AnimatePresence>
      {isLoadingContents ? (
        <>
          <div className="flex  gap-8 basis-3/4 rounded-md md:ml-8 ml-2 shadow-md">
            <div className=" full-screen">
              <Lottie options={defaultOptions} height={100} width={100} />
            </div>
          </div>
        </>
      ) : (
        <motion.form
          variants={childVariants}
          initial="initial"
          animate="final"
          className="flex flex-1 gap-12 rounded-md shadow-md"
        >
          {notPayed ? (
            <>
              <motion.div
                ref={pdfRef}
                initial="hidden"
                animate="visible"
                exit="hidden"
                variants={variants}
                key="paymentForm"
                className="max-w-5xl border border-dashed rounded-lg border-gray-600 mr-2 md:mr-12 md:mt-8 p-2 flex flex-1 "
              >
                <div className="flex mx-5 flex-col justify-between mt-4 flex-1">
                  <LineShowInfo
                    labeltxt="مبلغ سفته "
                    valuelable={
                      garanteeData?.data?.promissory_note_info
                        .promissory_note_price
                    }
                    valuelablep2={"تست"}
                    fontBoldLabel={true}
                  />
                  <LineShowInfo
                    labeltxt="تاریخ صدور"
                    valuelable={
                      garanteeData?.data?.promissory_note_info.date_of_issue.split(
                        "T"
                      )[0]
                    }
                  />
                  <LineShowInfo
                    labeltxt="تاریخ سررسید"
                    valuelable={"عندالمطالبه"}
                  />
                  <LineShowInfo
                    labeltxt=" بانک عامل"
                    valuelable={
                      garanteeData?.data?.promissory_note_info.agent_bank
                    }
                    icon="/icons/Pasargad.svg"
                  />
                  <div className=" flex-1 w-full border border-dashed rounded-lg border-gray-600 mx-auto mt-6 ">
                    <div className="flex justify-center flex-1 items-center pl-4 pr-4">
                      <label className="text-BodyText/16/Bold mt-2">
                        اطلاعات صادر کننده
                      </label>
                    </div>
                    <div className="flex flex-col flex-1 mb-4">
                      <LineShowInfo
                        labeltxt=" نام و نام خانوادگی"
                        valuelable={garanteeData?.data?.sender_info.full_name}
                      />

                      <LineShowInfo
                        labeltxt="کدملی "
                        valuelable={garanteeData?.data?.sender_info.national_id}
                      />
                      <LineShowInfo
                        labeltxt="شماره همراه "
                        valuelable={
                          garanteeData?.data?.sender_info.phone_number
                        }
                      />
                      <LineShowInfo
                        labeltxt="کد پستی منزل "
                        valuelable={
                          garanteeData?.data?.sender_info.store_postal_code
                        }
                      />
                      <LineShowInfo
                        labeltxt="شماره شبا "
                        valuelable={garanteeData?.data?.sender_info.IBAN}
                      />
                      <LineShowInfo
                        labeltxt="توضیحات "
                        valuelable={garanteeData?.data?.sender_info.description}
                      />
                    </div>
                  </div>
                  <div className="lg:flex lg:flex-col p-4 mt-8">
                    <div className="lg:flex justify-between items-center  gap-2">
                      <div className="flex justify-center items-center">
                        <input
                          type="checkbox"
                          id="consentCheckbox"
                          className="h-5 w-5"
                          onChange={handleCheckboxChange}
                        />
                        <label
                          htmlFor="consentCheckbox"
                          className="ml-2 rounded-full text-Body-OneLine/14/Medium pr-2 text-gray-900"
                        >
                          اطلاعات سفته را تایید کرده و آن را میپذیرم.
                        </label>
                      </div>

                      <div className="lg:flex justify-center items-center">
                        <div className="flex justify-center">
                          <label className="text-Title/16/Regular pl-2">
                            مبلغ پرداختی:
                          </label>{" "}
                          <label className="text-Title/20/Bold">
                            {" "}
                            {paymentAmount}
                          </label>{" "}
                          <label className="text-Title/16/Regular pr-2 pl-4">
                            {" "}
                            ریال
                          </label>{" "}
                        </div>

                        <ButtonComponent
                          type="button"
                          disabled={!isCheckboxChecked}
                          className="mx-auto mt-4 lg:mt-0 w-[120px] h-10"
                          variant="filled"
                          onClick={goToPayment}
                        >
                          پرداخت
                        </ButtonComponent>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex absolute -bottom-24 -left-0 justify-center md:justify-end gap-1 pb-4 ">
                  <ButtonComponent
                    type="button"
                    className="mt-8 w-[120px] h-10"
                    variant="outlined"
                    onClick={onBack}
                  >
                    بازگشت
                  </ButtonComponent>
                  <ButtonComponent
                    type="button"
                    disabled
                    className="mt-8 w-[120px] h-10 mr-[8px]"
                    variant="filled"
                  >
                    ادامه
                  </ButtonComponent>
                </div>
              </motion.div>
            </>
          ) : (
            <motion.div
              initial="hidden"
              animate="visible"
              exit="hidden"
              variants={variants}
              key="confirmationMessage"
              className="flex flex-col gap-6 mx-auto my-auto mt-[10%] h-[550px]"
            >
              <div className="flex flex-col items-center justify-center">
                <div className="flex flex-col items-center justify-center">
                  <div className="w-full my-10">
                    {/* <img
                      src="/images/Frame.svg"
                      alt="congratulation img"
                      className="mr-12 "
                    /> */}
                    <Lottie options={defaultOptionsCard} width={500} />
                  </div>
                  <div className="text-HeadLine/32/Bold text-green-600 flex justify-center ">
                    پرداخت شما موفقیت آمیز بود!
                  </div>
                </div>
                <div className="text-center w-[251px] h-[128px]">
                  <label className="text-BodyText/16/Bold text-gray-800 ">
                    برای دریافت قرارداد خود بر روی گزینه <strong>ادامه</strong>{" "}
                    کلیک نمایید.{" "}
                  </label>
                </div>
              </div>
              <div className="flex absolute -bottom-10 -left-0 justify-center md:justify-end gap-1 pb-40">
                <ButtonComponent
                  className="mt-8 w-[120px] h-10"
                  variant="outlined"
                  disabled
                  type="button"
                >
                  بازگشت
                </ButtonComponent>
                <ButtonComponent
                  type="button"
                  className="mt-8 w-[120px] h-10 mr-[8px]"
                  variant="filled"
                  onClick={() => setFormNo(formNo + 1)}
                >
                  تایید
                </ButtonComponent>
              </div>
            </motion.div>
          )}
        </motion.form>
      )}
    </AnimatePresence>
  );
};

export default Guarantee;
